import React from 'react';
import { useServicesChartsDataContext } from '../../hooks/useServicesChartsDataContext';
import useServicesPerYearDonutChart from './hooks/useServicesPerYearDonutChart';
import { Donut } from '../../../Charts/Donut';

export const ServicesPerYearDonut = ({ heigth = 300 }) => {
    const { module } = useServicesChartsDataContext();
    const { series, subtitles } = useServicesPerYearDonutChart();

    return (
        <Donut
            title={`Total ${module.sectionTitle} por Ano`}
            height={300}
            series={series}
            subtitles={subtitles}
        />
    );
};
